import React, { createContext, useContext, useEffect, useState } from "react";

import { applyTheme, getStoredTheme, saveTheme, themes } from "../utils/themes";

const ThemeContext = createContext(null);

export const useTheme = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error("useTheme must be used within ThemeProvider");
  }
  return ctx;
};

export const ThemeProvider = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState(getStoredTheme);

  useEffect(() => {
    applyTheme(currentTheme);
  }, [currentTheme]);

  const changeTheme = (themeName) => {
    if (!themes[themeName]) return;
    setCurrentTheme(themeName);
    saveTheme(themeName);
    applyTheme(themeName);
  };

  return (
    <ThemeContext.Provider value={{ currentTheme, theme: themes[currentTheme], changeTheme, themes }}>
      {children}
    </ThemeContext.Provider>
  );
};
